import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';

class Panel extends Component {
  static propTypes = {
    wide: PropTypes.bool,
    appHeight: PropTypes.number,
    appWidth: PropTypes.number,
    hide: PropTypes.bool,
    fullscreen: PropTypes.bool,
    padding: PropTypes.number,
    notVisible: PropTypes.bool,
    className: PropTypes.string,
  };
  get rendering() {
    let style = { };
    if (this.props.fullscreen && this.props.appHeight !== null) {
      style.height = this.props.appHeight + 'px';
    }

    if (this.props.fullscreen && this.props.appWidth && this.props.appWidth !== null) {
      style.width = this.props.appWidth + 'px';
    }

    if (this.props.padding) {
      style.padding = this.props.padding + 'px';
    }

    return style;
  }
  render() {
    let { wide, hide, fullscreen, notVisible } = this.props,
        panelClassName = 'app-panel' +
          (wide ? ' panel-wide' : '') +
          (hide ? ' panel-hide' : '') +
          (fullscreen ? ' panel-fullscreen' : '');

    return (
      <div style={notVisible ? { display: 'none' } : undefined} className={this.props.className}>
        <B.Grid fluid>
          <B.Row className="show-grid">
            <B.Col
              style={this.rendering}
              className={panelClassName}
              xs={12}
              sm={hide ? 12 : (wide ? 12 : 8)} smOffset={wide || hide ? 0 : 2}
              md={hide ? 12 : (wide ? 10 : 6)} mdOffset={hide ? 0 : (wide ? 1 : 3)}
            >
              {this.props.children}
            </B.Col>
          </B.Row>
        </B.Grid>
      </div>
    );
  }
};


export default Panel;



// WEBPACK FOOTER //
// ./components/Panel.js